import CreateMenu from './CreateMenu';
import EnvironmentSelector from './EnvironmentSelector';
import GlobalSearch from './GlobalSearch';
import UserProfile from './UserProfile';
import { PageActionsSlot } from '../context/PageActionsContext';
import { STROKE, LAYOUT, SURFACE } from '../theme/tokens';

// The AirBridge top bar — light, 56px (FD-ADR-043 §1.6).
//
// Search on the left; on the right, in order: the current page's own actions,
// the global `New` menu, the environment selector, and the signed-in operator.
//
// THE ORDER IS PAGE-SCOPED → GLOBAL → IDENTITY, reading left to right, and the
// identity control is last because that is where every Microsoft admin surface
// this console is measured against puts it. Operators arrive with that muscle
// memory; spending it is free and fighting it is not.
//
// FD-481 moved two things here. `CreateMenu` replaces the per-page CTAs the
// Groups page portalled in — creation is now reachable from every route rather
// than from whichever page happened to carry the button. And `UserProfile` came
// off the foot of the navy rail, where its name rendered near-black on navy (a
// Griffel class-merge defect; the mechanism is recorded in that file).
//
// ABSENT, DELIBERATELY (FD-ADR-043 D4): the notification bell and the help "?".
// Neither has anything behind it — there is no notification store and no
// in-product help — and a bell that never rings trains an operator to ignore it.

export default function TopBar() {
  return (
    <header
      className="flex shrink-0 items-center justify-between gap-6 border-b px-6"
      style={{
        height: LAYOUT.topBarHeight,
        backgroundColor: SURFACE.topBar,
        borderColor: STROKE.base,
      }}
    >
      <GlobalSearch />
      <div className="flex items-center gap-3">
        <PageActionsSlot />
        <CreateMenu />
        {/* `surface="light"` (FD-456) — the same control the production dark bar
            carried, told which chrome it is on. On a single-environment console
            it renders nothing at all, exactly as it does today. */}
        <EnvironmentSelector surface="light" />
        <div
          aria-hidden="true"
          className="h-6 w-px shrink-0"
          style={{ backgroundColor: STROKE.base }}
        />
        <UserProfile />
      </div>
    </header>
  );
}
